// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BidPlacingBackground_imageWrapper"};